import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ShiftReportItem } from '@app/core/global-state';
import { GroupedKpiValue } from '@app/shared/models';
import { OverviewModalService } from '@app/modules/shift-report/services/overview-modal';
import { KpiCategory } from 'chronos-core-client';
import { ModalService } from '../../services/overview-modal/modal.service';
import { ManageExternalProductOrderIdService } from '../../services/overview-modal/manageExternalProductOrderIdService.service';
import { ShiftReportService } from '@app/modules/shift-report/services';

@Component({
  selector: 'app-overview-modal',
  templateUrl: './overview-modal.component.html',
  styleUrls: ['./overview-modal.component.scss']
})
export class OverviewModalComponent implements OnInit {
  public kpis: GroupedKpiValue;
  public shiftReportItem: ShiftReportItem;
  public readonly KPI_CATEGORY = KpiCategory;

  constructor(
    private overviewModalService: OverviewModalService,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private modalService: ModalService,
    private productionOrderExternalIdService: ManageExternalProductOrderIdService,
    private shiftReportService: ShiftReportService,
  ) {}

  public ngOnInit(): void {
    this.shiftReportItem = this.config.data.shiftReportItem;

    this.shiftReportService.getProductionOrderKpis(this.shiftReportItem.productionOrder.productionOrderId).subscribe((kpis) => {
      this.kpis = this.overviewModalService.groupKpis(kpis);
    });

    this.productionOrderExternalIdService.setExternalProductionOrderId(this.config.data.shiftReportItem.productionOrder.code);

    // Close the modal when the closeModal$ observable emits a value
    // This is used to close the dialog when the user clicks on the edit button in the kpi tile
    this.modalService.closeModal$.subscribe(() => {
      this.clearExternalId();
      this.ref.close();
    });
  }

  public closeModal() {
    this.clearExternalId();
    this.ref.close();
  }

  public formatColumnTitle(title: string): string {
    return `FINISH_PHASE.${title.toUpperCase()}`;
  }

  private clearExternalId() {
    this.productionOrderExternalIdService.clearExternalProductionOrderId();
  }
}
